import * as React from "react";
import { useTranslation } from "react-i18next";
import { IContainerHistoryPoint } from "../interfaces/IContainerHistoryPoint";
import { wrapperStyles } from "../../storeMap/styles/style";

export interface IContainerDetailPopupHtml {
    containerDetail?: any;
}

export const ContainerDetailPopupHtml: React.FC<IContainerDetailPopupHtml> = ({ containerDetail }) => {
    const { t } = useTranslation("admin");
    return (
        <div style={wrapperStyles.popupStyles}>
            <div style={wrapperStyles.popupStyles}>
                {t("containers.popup.lastReading")} {containerDetail.lastActiveDateStr}< br />
                {(containerDetail.imei != undefined && containerDetail.imei != 0) ? <>{t("containers.popup.imei")} {containerDetail.imei} < br /> </> : <></>}
                {containerDetail.iccid != undefined ? <>{t("containers.popup.iccid")} {containerDetail.iccid} < br /> </> : <></>}
            </div>
        </div>
    )
}